import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Http, Headers, Request, Response, RequestOptions, RequestMethod } from '@angular/http';
import { HeaderFactory } from '../../common/HeaderFactory'
import { ScaleValidateModel } from '../models/ScaleValidateModel';

declare const OUTCOMES_API: string;

@Injectable()
export class ScaleValidateService {

    constructor(
        private http: Http,
        private headerFactory: HeaderFactory
    ) {
        //
    }

    checkStatus(institutionId: number): Observable<ScaleValidateModel> {
        return this.http.get(OUTCOMES_API + '/scale-validate/' + institutionId, {
            headers: this.headerFactory.make()
        }).map(res => res.json());
    }

    fixScales(institutionId: number): Observable<ScaleValidateModel> {       
        return this.http.get(OUTCOMES_API + '/fix-scales/' + institutionId, {
            headers: this.headerFactory.make()
        }).map(res => res.json());
    }
}


/** WEBPACK FOOTER **
 ** ./app/scalevalidate/services/ScaleValidateService.ts
 **/